module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dkFny"))).then(() => parcelRequire('hEqeo'));